var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.52,
    height: 34.648,
    viewBox: "0 0 39.52 34.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dfeef7;}.b{fill:none;stroke:#1f3951;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1187.25 -776.092)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M482.069,275.267v1.894l-18.254,18.262-6.64-6.643,21.2-22.995,3.7,3.7v5.781Z",
    transform: "translate(739.922 515.316)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1188 776.842)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.579 12.168)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M466.766,286.7c-.74.74-.446,2.233.656,3.335s2.3,1.7,3.335.656.445-2.233-.656-3.335h0c-1.1-1.1-1.627-2.364-.656-3.335s2.233-.445,3.335.656,1.4,2.6.656,3.335",
    transform: "translate(-466.358 -283.512)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 1.2,
    x2: 1.199,
    transform: "translate(18.998 12.137)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 1.199,
    x2: 1.199,
    transform: "translate(12.373 18.762)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M474.439,272.422V274.3L456.351,292.39,442.11,278.147,460.2,260.056h7.6l6.638,6.639v2.564",
    transform: "translate(-442.11 -260.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M489.566,273.917a2.286,2.286,0,1,1,0-3.232A2.286,2.286,0,0,1,489.566,273.917Z",
    transform: "translate(-463.068 -264.848)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M492.165,274.771c3.509,1.183,14.369,3.22,11.586,9.259a5.344,5.344,0,0,1-6.48,2.413",
    transform: "translate(-466.202 -267.139)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.c7b868765b299689076138064de2c3ff.svg";
export { ForwardRef as ReactComponent };